import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { VistoriaDTO } from 'app/model/dtos/mob/vistoria.dto';
import { VistoriaService } from 'app/services/mob/vistoria.services';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'dropdown-endereco',
  templateUrl: './dropdown-endereco.component.html',
  styleUrls: ['./dropdown-endereco.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class DropdownEnderecoComponent implements OnInit {

  endereco = new VistoriaDTO();
  formGroup: FormGroup;
  enderecos: VistoriaDTO[] = [];

  constructor(
    private _vistoriaService: VistoriaService,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.load();
  }
  
  async load(){
    let enderecos: VistoriaDTO[] = await this._vistoriaService.getEnderecos();
    for(let i = 0; i< enderecos.length; i++) {
      let endereco = new VistoriaDTO();
      endereco.nmLogradouro = `${enderecos[i].nmLogradouro}, ${enderecos[i].nrEndereco}, ${enderecos[i].nmBairro}`;
      endereco.cdEndereco = enderecos[i].cdEndereco;
      endereco.cdPessoaOrgao = enderecos[i].cdPessoaOrgao;
      this.enderecos.push(endereco);
    }
  }

  enderecoSelecionado(endereco: VistoriaDTO){
    this.formGroup.get('vistoriaEndereco').get('cdEndereco').patchValue(endereco.cdEndereco);
    this.formGroup.get('vistoriaEndereco').get('cdPessoa').patchValue(endereco.cdPessoaOrgao);
  }
}
